// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "thead.is-sticky[data-v-4b9d604e],thead.is-sticky th[data-v-4b9d604e]{position:sticky;top:0}.widget-link[data-v-4b9d604e]:hover{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
